import type {DomAndDmContext} from './types'

const getWindow = (): Window => {
    if (window.document.location.href.includes('editor/web/renderer/render')) {
        return window
    }
    return (window.document.getElementById('preview') as HTMLIFrameElement).contentWindow as Window
}

export const getDomAndDmContent = (): DomAndDmContext => {
    const _window = getWindow()
    return {
        window: _window,
        document: _window.document,
        documentServices: _window.documentServices,
        documentManager: _window.dsAdapter?.host.documentManager,
        viewerManager: _window.dsAdapter?.host.viewerManager,
        soq: _window.dsAdapter?.ps.setOperationsQueue
    }
}
